import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { IProjectAOI } from "../../../interfaces/i-project-aoi";
import { IMetadataImage } from "../../../interfaces/i-metadataimage";
import { DocumentService } from "../../../services/internal-services/document.service";
import { GeoService } from "../../../services/internal-services/geo.service";
import { MapService } from "../../../services/internal-services/map.service";
import { ICollection } from "../../../interfaces/i-collection";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-aoi-panel",
  templateUrl: "./aoi-panel.component.html",
  styleUrls: ["./aoi-panel.component.scss"],
  standalone: false,
})
export class AoiPanelComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true })
  paginator: MatPaginator;

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  dataSource: MatTableDataSource<IProjectAOI>;

  expandedElement: IMetadataImage | null;

  displayedColumns: string[] = ["layer", "parent", "name", "type", "min_date", "max_date", "orientations"];

  _aois: IProjectAOI[];

  @Input()
  set aois(aois: IProjectAOI[]) {
    this._aois = aois;
    if (this.dataSource) {
      this.dataSource.data = this._aois;
    }
  }

  @Output() fitEvent = new EventEmitter<string>();

  @Output() paintCoverageEvent = new EventEmitter<{
    wkt: any;
    id: string;
  }>();

  @Output() deleteCoverageEvent = new EventEmitter<string>();

  @Output() closeEvent = new EventEmitter<boolean>();

  selected: IProjectAOI;

  showImages = false;

  constructor(private mapService: MapService) {}

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this._aois) {
      this.dataSource.data = this._aois;
    }
  }

  filter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  fit(aoi: IProjectAOI) {
    //todo this fails with multilayer
    const collection = this.findCollection(aoi);
    const bbox = GeoService.bbox(collection.geometry);
    this.fitEvent.emit(bbox);
  }

  findCollection(aoi): ICollection {
    return this.mapService.getCollectionManager().getCollectionsById(aoi.getName());
  }

  paint(aoi: IProjectAOI) {
    //todo this fails with multilayer
    const collection = this.findCollection(aoi);
    const wkt = GeoService.geoJSONFeatureToWKT(GeoService.toWgs84(collection));
    this.paintCoverageEvent.emit({
      wkt,
      id: aoi.getLayerId(),
    });
  }

  delete(aoi: IProjectAOI) {
    this.deleteCoverageEvent.emit(aoi.getLayerId());
  }

  copy(aoi: any) {
    const collection = this.findCollection(aoi);
    const wkt = GeoService.geoJSONFeatureToWKT(GeoService.toWgs84(collection));
    DocumentService.copyTextToClipboard(wkt);
  }

  showImagePanel(aoi: IProjectAOI) {
    this.selected = aoi;
    this.showImages = true;
  }

  removeImagePanel() {
    this.selected = null;
    this.showImages = false;
  }

  close() {
    this.closeEvent.emit(true);
  }
}
